export enum UserInfoRole {
  SUPERADMIN = 'SUPERADMIN',
  OPERATIONS = 'OPERATIONS',
  SALES = 'SALES',
}

export const categorizedAsAdminRoleList = ['SUPERADMIN', 'OPERATIONS'];
